import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, FormControl, InputGroup } from 'react-bootstrap'
import '../components/css/ChatEntry.css'

class ChatEntry extends Component {
    constructor(props) {
        super(props)
        this.bigStyle = false
        this.isIE = false
        this.state = {
            message: '',
            inputContainerCSS: 'inputContainer',
            btnBackground: 'btnBackground',
            chatSendBtn: 'chatSendButton',
            sidebarInputContainerCSS: 'sidebarInputContainer',
            sidebarInputGroupCSS: 'sidebarInputGroup',
            sidebarBtnBackground: 'sidebarBtnBackground',
            //bigStyle: false,
        }
    }
    componentDidMount() {
        this.isIE = /*@cc_on!@*/false || !!document.documentMode

    }
    sendMessage() {
        let msg = this.state.message

        if (msg!== '') {
            this.props.onNewMessage(msg)
            this.setState({ message: '' })
        }
        else if (msg.trim() !== '') {
            this.props.onNewMessage(msg)
            this.setState({ message: '' })
        }
    }

    handleInput(e) {
        let txtCon = document.getElementById('inputContainer')
        let sidebarTxtCon = document.getElementById('sidebarInputContainer')

        if(txtCon !== null){
            if ((e.key === 'Enter' && e.shiftKey) || (e.key === 'Enter' && e.ctrlKey) || (e.key === 'Enter' && e.key === 'Meta')) {
                e.preventDefault()
                this.setState({message: e.target.value + '\n'})
            } else if (e.key === 'Enter') {
                e.preventDefault()
                this.sendMessage()
            } else {
                this.setState({ message: e.target.value })
            }
        }

        if(sidebarTxtCon !== null){
            if ((e.key === 'Enter' && e.shiftKey) || (e.key === 'Enter' && e.ctrlKey)) {
                e.preventDefault()
                // sidebar
                this.setState({message: e.target.value + '\n'})
            } else if (e.key === 'Enter') {
                e.preventDefault()
                this.sendMessage()
            } else {
                this.setState({ message: e.target.value })
            }
        }
    }

    render() {
        let inputContainerStyle = 'inputContainer'
        let btnBackgroundStyle = 'btnBackground'
        let sendBtnStyle = 'chatSendButton'
        let inputGroupStyle = 'inputGroupStyle'
        let msg = this.state.message
        if (this.isIE) {
            // IE discussion
            if (this.props.isIdeaPage === true) {
                if ((msg.length < 105 && !msg.includes('\n'))) {
                    inputContainerStyle = 'inputContainerIE'
                    btnBackgroundStyle = 'btnBackground'
                    sendBtnStyle = 'chatSendButton'
                    inputGroupStyle = 'inputGroupStyleIE'
                } else {
                    inputContainerStyle = 'inputContainerBigIE'
                    btnBackgroundStyle = 'btnBackgroundBig'
                    sendBtnStyle = 'chatSendButtonBig'
                    inputGroupStyle = 'inputGroupStyleIE'
                }
            }
            // IE sidebar
            if (this.props.isIdeaPage === false) {
                if ((msg.length < 105 && !msg.includes('\n'))) {
                    inputContainerStyle = 'sidebarInputContainerIE'
                    inputGroupStyle = 'sidebarInputGroupIE'
                    btnBackgroundStyle = 'sidebarBtnBackground'
                    sendBtnStyle = 'chatSendButton'
                } else {
                    inputContainerStyle = 'inputContainerBigIE'
                    inputGroupStyle = 'sidebarInputGroupBigIE'
                    btnBackgroundStyle = 'btnBackgroundBig'
                    sendBtnStyle = 'chatSendButtonBig'
                }
            }
        } else {
            // discussion
            if(this.props.isIdeaPage === true) {
                if ((msg.length < 105 && !msg.includes('\n'))) {
                    inputContainerStyle = 'inputContainer'
                    btnBackgroundStyle = 'btnBackground'
                    sendBtnStyle = 'chatSendButton'
                    inputGroupStyle = 'inputGroupStyle'
                } else {
                    inputContainerStyle = 'inputContainerBig'
                    btnBackgroundStyle = 'btnBackgroundBig'
                    sendBtnStyle = 'chatSendButtonBig'
                }
            }
            // sidebar
            if(this.props.isIdeaPage === false) {
                if ((msg.length < 105 && !msg.includes('\n'))) {
                    inputContainerStyle = 'sidebarInputContainer'
                    inputGroupStyle = 'sidebarInputGroup'
                    btnBackgroundStyle = 'sidebarBtnBackground'
                    sendBtnStyle = 'chatSendButton'
                } else {
                    inputContainerStyle = 'inputContainerBig'
                    inputGroupStyle = 'sidebarInputGroupBig'
                    btnBackgroundStyle = 'btnBackgroundBig'
                    sendBtnStyle = 'chatSendButtonBig'
                }
            }
        }
        return (
            <div className='chatEntryContainer'>
                {(this.props.isIdeaPage === true) &&
                    // discussion
                    <FormGroup controlId='formControlsTextarea'>
                        <InputGroup className={inputGroupStyle}>
                            <InputGroup.Addon className='ideaPageChatGapLeft'>
                                <div className='chatSideGapRight' />
                            </InputGroup.Addon>
                            <div id='inputContainer' className={inputContainerStyle}>
                                <FormControl componentClass='textarea' className='commentInput'
                                    type='text'
                                    value={this.state.message}
                                    placeholder='Add a comment...'
                                    onChange={this.handleInput.bind(this)}
                                    onKeyPress={this.handleInput.bind(this)}
                                    onKeyDown={this.handleInput.bind(this)}
                                />
                            </div>
                            <InputGroup.Addon className='chatEmptyGapContainer'>
                                <div className='chatEmptyGap' />
                            </InputGroup.Addon>
                            <InputGroup.Addon className={btnBackgroundStyle}>
                                <div onClick={this.sendMessage.bind(this)} id='chatSendButton' className={sendBtnStyle}>Send</div>
                            </InputGroup.Addon>
                            <InputGroup.Addon className='ideaPageChatGapRight'>
                                <div className='chatSideGapLeft' />
                            </InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                }
                {(this.props.isIdeaPage === false) &&
                    // sidebar
                    <FormGroup controlId='formControlsTextarea'>
                        <InputGroup className={inputGroupStyle}>
                            <InputGroup.Addon className='chatEmptyContainer'>
                                <div className='chatSideGapRight' />
                            </InputGroup.Addon>
                            <div id='sidebarInputContainer' className={inputContainerStyle}>
                                <FormControl componentClass='textarea' className='commentInput'
                                    type='text'
                                    value={this.state.message}
                                    placeholder='Add a comment...'
                                    onChange={this.handleInput.bind(this)}
                                    onKeyPress={this.handleInput.bind(this)}
                                    onKeyDown={this.handleInput.bind(this)}
                                />
                            </div>
                            <InputGroup.Addon className='chatEmptyGapContainer'>
                                <div className='chatEmptyGap' />
                            </InputGroup.Addon>
                            <InputGroup.Addon className={btnBackgroundStyle}>
                                <div onClick={this.sendMessage.bind(this)} className={sendBtnStyle}>Send</div>
                            </InputGroup.Addon>
                            <InputGroup.Addon className='chatEmptyContainer'>
                                <div className='chatSideGapLeft' />
                            </InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                }
            </div>
        )
    }
}
ChatEntry.propTypes = {
    onNewMessage: PropTypes.func.isRequired,
    userName: PropTypes.string.isRequired,
    userPhotoURL: PropTypes.string,
}

export default ChatEntry



// WEBPACK FOOTER //
// ./src/components/ChatEntry.js